import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { useCookieConsent } from '@/hooks/useCookieConsent';
import { initializeAnalytics, trackPageView } from '@/lib/analytics';
import { CookieConsentBanner } from './CookieConsentBanner';

interface AnalyticsProviderProps {
  children: React.ReactNode;
}

export function AnalyticsProvider({ children }: AnalyticsProviderProps) {
  const location = useLocation();
  const {
    consent,
    showBanner,
    isLoading,
    acceptAll,
    rejectNonEssential,
    saveCustom,
    dismissPermanently,
  } = useCookieConsent();

  // Initialize third-party analytics when consent changes
  useEffect(() => {
    if (consent) {
      initializeAnalytics(consent);
    }
  }, [consent]);

  // Track page views on route change
  useEffect(() => {
    if (consent?.analytics) {
      trackPageView(location.pathname, document.title);
    }
  }, [location.pathname, consent?.analytics]);

  if (isLoading) {
    return <>{children}</>;
  }

  return (
    <>
      {children}
      
      <AnimatePresence>
        {showBanner && (
          <CookieConsentBanner
            onAcceptAll={acceptAll}
            onRejectNonEssential={rejectNonEssential}
            onSaveCustom={saveCustom}
            onDismiss={dismissPermanently}
          />
        )}
      </AnimatePresence>
    </>
  );
}
